import { render, staticRenderFns } from "./suWoplanAudit.vue?vue&type=template&id=565d5526&scoped=true"
import script from "./suWoplanAudit.vue?vue&type=script&lang=js"
export * from "./suWoplanAudit.vue?vue&type=script&lang=js"
import style0 from "./suWoplanAudit.vue?vue&type=style&index=0&id=565d5526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565d5526",
  null
  
)

export default component.exports